import React from 'react';
import PlusSmall from '@uber/base-icons/plus-small';
import { Button, KIND, SIZE } from 'baseui/button';
import type { Theme } from 'baseui/theme';
import { useAtomValue, useSetAtom } from 'jotai';
import { TOOL } from '../../../labelling/constants';
import { annotationLabelsAtom } from '../../atoms/annotation-atoms';
import { sidePanelDispatchAtom } from './side-panel';
const buttonOverrides = {
  Root: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      marginLeft: $theme.sizing.scale200
    })
  }
};
const isInstanceLabel = (labelName: string) => {
  if (!labelName.includes('_')) {
    return false;
  }
  return true;
};
export const InstanceSegmentationButton = ({
  labelName
}: {
  labelName: string;
}) => {
  const annotationLabels = useAtomValue(annotationLabelsAtom);
  const dispatch = useSetAtom(sidePanelDispatchAtom);
  const currentLabel = annotationLabels.find(label => label.title === labelName);
  if (!currentLabel) {
    return;
  }
  if (!currentLabel.tools?.includes(TOOL.SEGMENTATION) || isInstanceLabel(labelName)) {
    return;
  }
  return <Button kind={KIND.secondary} size={SIZE.mini} overrides={buttonOverrides} onClick={e => {
    e.stopPropagation();
    dispatch({
      type: 'ADD_INSTANCE_LABEL',
      labelName
    });
  }}>
      <PlusSmall title={'Add instance segment'} />
    </Button>;
};